/*=========================================================================================
  File Name: moduleStats.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from './moduleStoriesState.js';
import mutations from './moduleStoriesMutations.js';
import actions from './moduleStoriesActions.js';
import getters from './moduleStoriesGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
